// extracted by mini-css-extract-plugin
export default {"SortingArrow":"AllResourceView_SortingArrow__65HNy","SortingArrowEnabled":"AllResourceView_SortingArrowEnabled__6I9FF"};